import Item from "antd/es/list/Item";
import { routeabsheader, routedetails } from "./mainabstract";
import { formatDate } from "@progress/kendo-intl";
import { useState } from "react";
import IndentTimer from "./indent.component.timer";
import dayjs from "dayjs";
import { date } from "yup";

interface IRouteDetailHeader {
  routeDetailHeader: routedetails;
}
export const IndentAbstractDetail = (props: IRouteDetailHeader) => {
  const { routeDetailHeader } = props;
  const dateTime = dayjs(new Date()).format("YYYY-MM-DD") + "T" + routeDetailHeader?.morningorderexpirytime;
  console.log("DATE",dateTime);
  //'2025-02-11T17:00:00'
  return (
    <>
    <div><IndentTimer targetTime={ new Date (dateTime)} ></IndentTimer></div>
    <table style={{ width: "100%", backgroundColor:"#E5E4E2", borderRadius:"5px", marginBottom:"10px"}} border={0} cellPadding={15} cellSpacing={15}>
      <tr style={{ borderRadius: "5px" }}>
        <th>Route Name:</th>
        <td>{routeDetailHeader?.rname}</td>
        <th>Shift:</th>
        <td>{routeDetailHeader?.shift}</td>
        <th>Order Date:</th>
        <td>{formatDate(new Date(routeDetailHeader?.orderdate), "dd-MM-yyyy")}</td>
        <th>Active Customers:</th>
        <td>{routeDetailHeader?.activecustomer}</td>
        <th>Dispatched?:</th>
        <td>{routeDetailHeader?.isdespatched?"Yes": "No"}</td>
      </tr>
    </table>
    </>
  );
};
